import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import ConfirmModal from '../components/ConfirmModal';
import {api} from '../api';

export default function OrgAdmin() {
  const navigate = useNavigate();
  const [tenants, setTenants] = useState([]);
  const [form, setForm] = useState({name: ''});
  const [editing, setEditing] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const load = () => api('/tenants').then(r => r.ok ? r.json() : []).then(setTenants).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editing) {
      await api(`/tenants/${editing}`, {method: 'PUT', body: JSON.stringify(form)});
    } else {
      await api('/tenants', {method: 'POST', body: JSON.stringify(form)});
    }
    setForm({name: ''});
    setEditing(null);
    load();
  };

  const startEdit = (t) => { setEditing(t.id); setForm({name: t.name}); };

  const handleDelete = async () => {
    await api(`/tenants/${deleteTarget}`, {method: 'DELETE'});
    setDeleteTarget(null);
    load();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
          <div className="flex items-center gap-4">
            <img src="/images/matterking-logo.png" alt="Matter King" className="h-10 w-auto" />
            <h1 className="text-lg font-bold text-gray-900">Organization Admin</h1>
          </div>
          <button onClick={() => navigate('/tenants')} className="text-gray-600 hover:text-gray-900 text-sm font-medium">&larr; Back</button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Manage Organizations</h2>

        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-4 mb-6 flex flex-col sm:flex-row gap-3 sm:items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
            <input required value={form.name} onChange={(e) => setForm({name: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500" />
          </div>
          <div className="flex gap-3">
            <button type="submit" className="flex-1 sm:flex-none px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 whitespace-nowrap">
              {editing ? 'Update' : 'Add'}
            </button>
            {editing && <button type="button" onClick={() => { setEditing(null); setForm({name: ''}); }} className="flex-1 sm:flex-none px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>}
          </div>
        </form>

        <div className="bg-white rounded-lg shadow overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b text-left text-sm text-gray-500">
                <th className="p-4">Name</th>
                <th className="p-4">Created</th>
                <th className="p-4"></th>
              </tr>
            </thead>
            <tbody>
              {tenants.map(t => (
                <tr key={t.id} className="border-b last:border-0 hover:bg-gray-50">
                  <td className="p-4 font-medium text-gray-900">{t.name}</td>
                  <td className="p-4 text-gray-500 text-sm">{new Date(t.createdAt).toLocaleDateString()}</td>
                  <td className="p-4 text-right">
                    <button onClick={() => startEdit(t)} className="text-sm text-gray-600 hover:text-gray-900 mr-3">Edit</button>
                    <button onClick={() => setDeleteTarget(t.id)} className="text-sm text-red-600 hover:text-red-800">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
      <ConfirmModal open={!!deleteTarget} title="Delete Organization" message="Are you sure? All data for this organization will be lost."
        onConfirm={handleDelete} onCancel={() => setDeleteTarget(null)} />
    </div>
  );
}